/**
 * media-kind —— 根据 URL 判断资源是视频还是图片。
 *
 * CG 节点 (type=cg_show) 的 url 可能是静态图（png/jpg/webp/gif）也可能是短视频
 * (mp4/webm/mov)。后端只存 url，前端拿到什么就播什么 —— 本模块是那个判定逻辑。
 *
 * 规则：看 URL pathname 的扩展名（忽略 query/hash）。未知扩展一律按 image 处理，
 * 这是 CG 历史默认行为；真正拿到 404 时还有 onError 兜底（见 play page）。
 */
const VIDEO_EXTS = new Set(["mp4", "webm", "mov", "m4v", "ogv"]);
export function detectMediaKind(url) {
    if (!url)
        return "image";
    const ext = extractExt(url);
    return VIDEO_EXTS.has(ext) ? "video" : "image";
}
function extractExt(url) {
    // 截到 query/hash 之前
    const clean = (url.split("?")[0] ?? "").split("#")[0] ?? "";
    const dot = clean.lastIndexOf(".");
    if (dot < 0 || dot === clean.length - 1)
        return "";
    const slash = clean.lastIndexOf("/");
    if (dot < slash)
        return ""; // dot before final slash → no ext
    return clean.slice(dot + 1).toLowerCase();
}
